var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theme-transition",
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "theme-tranistion",
    clipPath: "url(#clip0_1_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.672 81.2532C156.671 92.2575 156.671 110.099 145.672 121.103C134.672 132.108 116.839 132.108 105.84 121.103C94.8403 110.099 94.8403 92.2575 105.84 81.2532C116.839 70.2489 134.672 70.2489 145.672 81.2532ZM71 161.145C102.342 188.954 149.663 188.949 181 161.145C149.663 133.342 102.342 133.338 71 161.145Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125.5,
    r: 124,
    stroke: "#757572",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/SocialMedia.ec1638c7313ee448c9f8338e40267564.svg";
export { ForwardRef as ReactComponent };